import React, {Component} from 'react';
import {connect} from 'react-redux';
import {ActionSheet, Button} from 'react-weui';
import Config from '../../config';

import '../../styles/transactionrecord/TransactionRecordTopFilter.css';

class TransactionRecordTopFilter extends Component {
    constructor() {
        super();

        this.renderFilterMenus = this.renderFilterMenus.bind(this);
        this.hide = this.hide.bind(this);
        this.state = {
            auto_show: false,
            filterMenus: [],
            has_background: false,
            actions: [
                {
                    label: '取消',
                    onClick: this.hide
                }
            ]
        };
    }

    renderFilterMenus() {
        const {filter, filterKey} = this.props;

        let filterMenus = filter.map((item) => {
            return {
                label: item.value,
                className: (item.selected || item.key === filterKey) ? 'filter-selected' : '',
                onClick: this.handleSelectFilter.bind(this, item.key)
            };
        });
        filterMenus.splice(0, 0, {label: '选择类型'});
        return filterMenus;
    }

    hide() {
        this.setState({auto_show: false})
    }

    handleSelectFilter(key) {
        const {loadData} = this.props;

        this.props.dispatch({
            type: 'TRANSACTION_RECORD_SET_FITLER',
            payload: key
        });
        loadData(key);
        this.hide();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }

    render() {
        let filterMenus = this.renderFilterMenus();


        return (
            <div className="transaction-record-top-filter">
                <div className="transaction-record-top-button">
                    <Link to='/wallet/'>
                        <a className="link-back" href="javascript:;">
                            <i className="back"> &lt; </i>
                            返回
                        </a>
                    </Link>
                    <span onClick={e => this.setState({auto_show: true})}>
                        <Button className="filter fr" size="small">筛选</Button>
                    </span>
                </div>
                <ActionSheet
                    type="ios"
                    actions={this.state.actions}
                    menus={filterMenus}
                    show={this.state.auto_show}
                    onRequestClose={this.hide}
                />
            </div>
        );
    }
}

export default connect((state) => ({
    filter: state.transactionRecord.filter,
    filterKey: state.transactionRecord.filterKey,
}))(TransactionRecordTopFilter)





// WEBPACK FOOTER //
// ./src/components/transactionrecord/TransactionRecordTopFilter.js